import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DEFAULT_CSS, StartupServices, TENANT_THEME_KEY } from 'src/app/extensions/constants/commonConstants';
import { TenantAPIService } from 'src/app/extensions/services/api/tenant-api.service';
import { LoaderService } from 'src/app/extensions/services/loader.service';

@Component({
  selector: 'style-loader',
  templateUrl: './style-loader.component.html',
  styleUrls: ['./style-loader.component.scss'],
  standalone: false,
})
export class StyleLoaderComponent implements OnInit {
  public constructor(
    private _title: Title,
    private _fileAPIService: TenantAPIService,
    private _loaderService: LoaderService
  ) {}

  public ngOnInit(): void {
    this._loaderService.registerService(StartupServices.StyleLoader);

    let lsTenantTheme = localStorage.getItem(TENANT_THEME_KEY);
    if (lsTenantTheme == null || (JSON.parse(lsTenantTheme) as app.models.Theme).isDefault) {
      this.uploadCssData(DEFAULT_CSS);
    } else {
      const tenantTheme = JSON.parse(lsTenantTheme) as app.models.Theme;
      const pageTitle = getComputedStyle(document.documentElement).getPropertyValue('--page-title').slice(1, -1);
      this._title.setTitle(pageTitle);
      this.loadCssData(tenantTheme.data);
    }

    this._loaderService.finishServiceLoad(StartupServices.StyleLoader);
  }

  private loadCssData(data: string) {
    let themeLink = document.getElementById('client-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.innerHTML = data;
    } else {
      const style = document.createElement('style');
      style.id = 'client-theme';
      style.innerHTML = data;

      const head = document.getElementsByTagName('head')[0];
      head.appendChild(style);
    }

    let customFavicon = getComputedStyle(document.documentElement).getPropertyValue('--fav-icon').slice(1, -1);
    if (customFavicon.length > 0) {
      const defaultFavicon = document.getElementById('default-favicon');
      if (defaultFavicon) {
        defaultFavicon.setAttribute('href', customFavicon);
        defaultFavicon.setAttribute('id', 'client-favicon');
      }
    }
  }

  private uploadCssData(data: string) {
    this._fileAPIService.SaveTenantTheme(data).subscribe(x => {});
  }
}
